module.exports = __webpack_public_path__ + "img/offshoresms-new-logo.5a1054e5.png";